import EcoPicture from 'eco-design/base/eco-picture';
import css from './index.module.scss';
import { ItfCard } from './type';
import { useLang } from '@/i18n';

const G: React.FC = () => {
    const { t } = useLang('aboutus.G');

    const cards: ItfCard[] = [
        {
            text: t('card1_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442483/1_best.png',
        },
        {
            text: t('card2_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442646/2_if.png',
        },
        {
            text: t('card3_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054442860/3_ces.png',
        },
        {
            text: t('card4_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443136/4_reddot.png',
        },
        {
            text: t('card5_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443366/5_ux.png',
        },
        {
            text: t('card6_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443415/6_yd.png',
        },
        {
            text: t('card7_text'),
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766054443797/7_tech.png',
        },
    ];
    return (
        <div id="about-US-G" className={`about-US-G ${css.section} GtmModuleData-section`} data-section-id={'about-US-G'}>
            <div className="box1">
                <div className="img">
                    <EcoPicture
                        jpg={[
                            'https://websiteoss.ecoflow.com/figma-uploads/1768561409015-ixym9u-compressed-PC%E7%AB%AF.jpg',
                            'https://websiteoss.ecoflow.com/figma-uploads/1768561431463-6jswnt-compressed-Frame%201612707934.jpg',
                        ]}
                        alt={t('title')}
                    />
                </div>
                <div className="info">
                    <div className="title-container">
                        <div className="label">{t('label')}</div>
                        <h2 className="title">{t('title')}</h2>
                        <div className="desc">{t('desc')}</div>
                    </div>
                </div>
            </div>
            <div className="box2">
                <ul className="cards">
                    {[...cards, ...cards]?.map((card: ItfCard, i: number) => (
                        <li className="card" key={i}>
                            <div className="card-img">
                                <EcoPicture jpg={[card.logo]} />
                            </div>
                            <p className="card-text text">{card.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default G;
